import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_DEPORTES = 'ALL_DEPORTES';
export const LOADING_ALL_DEPORTES = 'LOADING_ALL_DEPORTES';
export const ACTIVO_DEPORTES = 'ACTIVO_DEPORTES';
export const PARAMS_DEPORTES = 'PARAMS_DEPORTES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const deportesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_DEPORTES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_DEPORTES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_DEPORTES:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_DEPORTES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
